import React from 'react';
import objstr from 'obj-str';
import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
import * as Types from '../../pages/mijn-carel-lurvink/catalogus/stores/types';
import styles from './ProductAttributeSelector.module.scss';

interface IColorAttributes {
  attribute: Types.SelectableVariantAttribute;
  attributes: Types.VariantAttributes[];
  onAttributeChange: AppCallbackFn;
  disableAllowed?: boolean;
}

type IHandleAttributeChange = {
  type: string;
  attributeValue: Types.MappedAttribute;
};
export const ColorAttributes = ({ attribute, attributes, onAttributeChange, disableAllowed = true }: IColorAttributes) => {
  const { t } = useTranslation('product-details');
  const handleAttributeChange = ({ type, attributeValue }: IHandleAttributeChange) => {
    onAttributeChange({ type, attributeValue });
  };

  return (
    <div className="mb-3">
      <strong className="d-block mb-2">{t(`attribute.${attribute.type}`)}</strong>
      <div className={styles.variantAttributes}>
        {attribute.values.map((attributeValue, idx: number) => {
          const { code, value, image = null, disabled = false } = attributeValue;

          const classNames = objstr({
            [styles.colorOption]: true,
            //@ts-expect-error: TS trips over dynamic keys
            [styles.colorOptionActive]: attributes[attribute.type] === code,
            [styles.disabled]: disableAllowed && disabled,
            transition: true,
            tooltip: true
          });

          return (
            <React.Fragment key={`${code}-${value}${idx}`}>
              <span className={classNames} onClick={() => handleAttributeChange({ type: attribute.type, attributeValue })} key={code}>
                {image && <Image src={image} alt={value} className={styles.colorImage} width="28" height="28" />}
                <span className="tooltip_text">{value}</span>
              </span>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};
